import React from 'react';
import classNames from 'classnames';
import DocumentHeaderButton from 'Components/DocumentHeaderButton';
import UIButton from 'Components/UIComponents/UIButton';
import { useIsMobile } from 'Hooks/Common';
import { DocumentActions } from 'Interfaces/Document';

import ModalHeaderActionButtons from './ModalHeaderActionButtons';
import ModalHeaderNavigateButtons from './ModalHeaderNavigateButtons';

export interface ModalHeaderProps {
  onScaleChange: (value: number) => void;
  handleSubmit: () => void;
  handleClose: () => void;
  documentScale: number;
  isSubmitting?: boolean;
  onCopy?: () => void;
  onPaste?: () => void;
  submitButtonTitle?: DocumentActions;
  isForm?: boolean;
  disabled?: boolean;
  isDisableCancelButton: boolean;
  redoDocumentFieldAction: () => void;
  undoDocumentFieldAction: () => void;
  isNextAvailable: boolean;
  isPrevAvailable: boolean;
  showNavigateButtons?: boolean;
  showFormButtons?: boolean;
}

function ModalHeader({
  handleClose,
  onScaleChange,
  documentScale,
  handleSubmit,
  isSubmitting = false,
  onCopy,
  onPaste,
  submitButtonTitle = DocumentActions.SEND,
  isForm,
  disabled,
  isDisableCancelButton,
  redoDocumentFieldAction,
  undoDocumentFieldAction,
  isNextAvailable,
  isPrevAvailable,
  showNavigateButtons = true,
  showFormButtons = true,
}: ModalHeaderProps) {
  const isMobile = useIsMobile();
  const areNavigateButtonsShown =
    showNavigateButtons || isPrevAvailable || isNextAvailable;

  return (
    <header className={classNames('interactModal__header', { mobile: isMobile })}>
      {!isMobile && (
        <h3 className="interactModal__header-title">
          {isForm ? 'Preparing Form' : 'Prepare for Signing'}
        </h3>
      )}
      <div className="interactModal__header-bar">
        {areNavigateButtonsShown && (
          <ModalHeaderNavigateButtons
            isPrevAvailable={isPrevAvailable}
            isNextAvailable={isNextAvailable}
            onUndo={undoDocumentFieldAction}
            onRedo={redoDocumentFieldAction}
          />
        )}
        <ModalHeaderActionButtons
          documentScale={documentScale}
          onScaleChange={onScaleChange}
          onCopy={onCopy}
          onPaste={onPaste}
        />
      </div>
      {showFormButtons && (
        <div className="interactModal__header-send">
          {!isDisableCancelButton && (
            <DocumentHeaderButton
              priority="cancel"
              className="interactModal__header-cancelButton"
              onClick={handleClose}
            >
              <span className="interactModal__header-bar-button-text">Cancel</span>
            </DocumentHeaderButton>
          )}
          <UIButton
            priority="primary"
            className="interactModal__header-submitButton"
            title={submitButtonTitle}
            disabled={disabled || isSubmitting}
            isLoading={isSubmitting}
            handleClick={handleSubmit}
          />
        </div>
      )}
    </header>
  );
}

export default ModalHeader;
